import { EventsSearchQueryParams } from '../models/open-days.models';

export const generateLink = (baseUrl: string, queryParams: EventsSearchQueryParams) => {
	if (!queryParams || typeof queryParams !== 'object') return baseUrl;

	const options = Object.entries(queryParams)
		.filter(([, value]) => value)
		.map(([key, value]) => `${key}=${value.toLowerCase().replace(/ /g, '-')}`);

	return options.length > 0 ? `${baseUrl}?${options.join('&')}` : `${baseUrl}`;
};
